import React, { lazy } from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";
import type { RouteObject } from "react-router-dom";

const HomePc = lazy(() => import('../ViewPc/Home/Home'))
const HomeIndex = lazy(() => import('../ViewPc/Home/HomeIndex/HomeIndex'))
const HomeSearch = lazy(() => import('../ViewPc/Home/HomeSearch/HomeSearch'))
const HomeDetails = lazy(() => import('../ViewPc/Home/HomeDetails/HomeDetails'))
const ServiceProvider = lazy(() => import('../ViewPc/ServiceProvider/ServiceProvider'))
const AboutAs = lazy(() => import('../ViewPc/AboutAs/AboutAs'))
const Secure = lazy(() => import('../ViewPc/Secure/Secure'))




const HomeMobail = lazy(() => import('../ViewMobile/Home'))
const HomeMobailIndex = lazy(() => import('../ViewMobile/Home/Home'))
const BeforeEach = lazy(() => import('../components/BeforeEach/BeforeEach'))
const HomeSolution = lazy(() => import('../ViewMobile/HomeSolution/HomeSolution'))
const HomeSearchMobail = lazy(() => import('../ViewMobile/Home/HomeSearch/HomeSearch'))
const HomeDetailsMobail = lazy(() => import('../ViewMobile/Home/HomeDetails/HomeDetails'))
const ServiceProviderMobaile = lazy(() => import('../ViewMobile/ServiceProviderMobaile/ServiceProviderMobaile'))
const AboutAsMobaile = lazy(() => import('../ViewMobile/AboutAsMobaile/AboutAsMobaile'))
const SecureMobaile = lazy(() => import('../ViewMobile/SecureMobaile/SecureMobaile'))



const NotAuth = lazy(() => import('../views/NotAuth/NotAuth'))
const NotFound = lazy(() => import('../views/NotFound/NotFound'))
const NotServer = lazy(() => import('../views/NotServer/NotServer'))


declare module 'react-router' {
  interface IndexRouteObject {
    meta?: {
      menu?: boolean
      title?: string
      icon?: React.ReactNode
      auth?: boolean
    },
    name?: string
  }
  interface NonIndexRouteObject {
    meta?: {
      menu?: boolean
      title?: string
      icon?: React.ReactNode
      auth?: boolean
    },
    name?: string
  }
}
let screenType = ''
const screenWidth = window.screen.width
if (/Mobi|Android|iPhone/i.test(navigator.userAgent)) {
  screenType = 'mobail'
} else {
  screenType = 'pc'
}

console.log(screenType)
export const routes: RouteObject[] = [
  {
    path: '/',
    element: React.createElement(Navigate, { to: '/homeIndex' })
  },
  {
    path: '/',
    name: 'home',
    element: screenType === 'mobail' ? React.createElement(BeforeEach, null, React.createElement(HomeMobail)) : React.createElement(BeforeEach, null, React.createElement(HomePc)),
    children: [
      {
        path: '/homeIndex',
        name: 'homeIndex',
        element: screenType === 'mobail' ? React.createElement(HomeMobailIndex) : React.createElement(HomeIndex),
      },
      {
        path: '/search',
        name: 'search',
        element: screenType === 'mobail' ? React.createElement(HomeSearchMobail) : React.createElement(HomeSearch),
      },
      {
        path: '/details/:id',
        name: 'details',
        element: screenType === 'mobail' ? React.createElement(HomeDetailsMobail) : React.createElement(HomeDetails),
      },
      {
        path: '/homesolution/:id',
        name: 'homesolution',
        element: screenType === 'mobail' ? React.createElement(HomeSolution) : React.createElement(HomeIndex),
      },
      {
        path: '/searchmobail',
        name: 'searchmobail',
        element: screenType === 'mobail' ? React.createElement(HomeSearchMobail) : React.createElement(HomeSearch),
      },
      {
        path: '/homedetailsmobail/:id',
        name: 'homedetailsmobail',
        element: screenType === 'mobail' ? React.createElement(HomeDetailsMobail) : React.createElement(HomeDetails),
      },
    ]
  },
  {
    path: '/serviceProvider',
    name: 'serviceProvider',
    element: screenType === 'mobail' ? React.createElement(BeforeEach, null, React.createElement(ServiceProviderMobaile)) : React.createElement(BeforeEach, null, React.createElement(ServiceProvider)),
  },
  {
    path: '/serviceProviderMobaile',
    name: 'serviceProviderMobaile',
    element: screenType === 'mobail' ? React.createElement(BeforeEach, null, React.createElement(ServiceProviderMobaile)) : React.createElement(BeforeEach, null, React.createElement(ServiceProvider)),
  },
  {
    path: '/aboutAs',
    name: 'aboutAs',
    element: screenType === 'mobail' ? React.createElement(BeforeEach, null, React.createElement(AboutAsMobaile)) : React.createElement(BeforeEach, null, React.createElement(AboutAs)),
  },
  {
    path: '/aboutAsMobaile',
    name: 'aboutAsMobaile',
    element: screenType === 'mobail' ? React.createElement(BeforeEach, null, React.createElement(AboutAsMobaile)) : React.createElement(BeforeEach, null, React.createElement(AboutAs)),
  },
  {
    path: '/secure',
    name: 'secure',
    element: screenType === 'mobail' ? React.createElement(BeforeEach, null, React.createElement(SecureMobaile)) : React.createElement(BeforeEach, null, React.createElement(Secure)),
  },
  {
    path: '/secureMobaile',
    name: 'secureMobaile',
    element: screenType === 'mobail' ? React.createElement(BeforeEach, null, React.createElement(SecureMobaile)) : React.createElement(BeforeEach, null, React.createElement(Secure)),
  },




  {
    path: '/403',
    element: React.createElement(NotAuth)
  },
  {
    path: '/404',
    element: React.createElement(NotFound)
  },
  {
    path: '/500',
    element: React.createElement(NotServer)
  },
  {
    path: '*',
    element: React.createElement(Navigate, { to: '/404' })
  }
];

const router = createBrowserRouter(routes)

export default router;